import React from 'react';

import draftIconSvg from '../../../assets/svgs/draftIcon.svg';
import driverIconSvg from '../../../assets/svgs/driverIcon.svg';

const SIDEBAR_ICON_STYLE = { width: 22, height: 22, flexShrink: 0 };

export const DraftIconFromSvg = () => (
  <img src={draftIconSvg} alt="" role="presentation" style={SIDEBAR_ICON_STYLE} />
);

export const DriverIconFromSvg = () => (
  <img src={driverIconSvg} alt="" role="presentation" style={SIDEBAR_ICON_STYLE} />
);

